import React, { useState, useEffect } from 'react';
import {  Box, IconButton, Grid, TextField, FormControlLabel, CircularProgress, List, ListItem  } from '@mui/material';
import { Save } from '@mui/icons-material';
import axios from 'axios';
import { Outlet, useLocation, useParams, useNavigate } from "react-router-dom";
import PageHeading from '../page_heading';
import CustomButton2 from "../common/button_two";
import ModelPopup from "../common/modal_popup";
import { basic, textFieldAndShrinkStyle } from '../../../themes/basic';
import LoadingOverlay from '../common/loading_overlay';
import MessageSnackbar from '../common/message_snackbar';
import CancelButton from '../common/button_cancel';

const EditVariant = () => {
  const { variantId } = useParams(); 
  const [__currentVariantId, __setCurrentVariantId] = useState(null);
  const [__productData, __setProductData] = useState(null);
  const [__variantNameValue, __setVariantNameValue] = useState(null);
  const [__variantDescription, __setVariantDescription] = useState(null);
  const [__modalOpen, __setModalOpen] = useState(false);
  const [__loading, __setLoading] = useState(false);
  const [__successMsg, __setSuccessMsg] = useState(null);
  const [__messageStatus, __setMessageStatus] = useState(null);
  const [__isVisible, __setIsVisible] = useState(false);
  const [__variantExists, __setVariantExists] = useState(false); 
  const [__checkMessage, __setCheckMessage] = useState(''); 
  const [__suggestions, __setSuggestions] = useState([]); 
  const [__fetchingSuggestions, __setFetchingSuggestions] = useState(false);
  const [__selecteProductId, __setSelecteProductId] = useState([]);
  const [__productVariantData, __setProductVariantData] = useState([]);
  const [__clickFetchSuggestionList, __setClickFetchSuggestionList] = useState(false);
  const [__errorMessage, __setErrorMessage] = useState('');
  const [__isVariantNameValid, __setIsVariantNameValid] = useState(true);

  const [__snackbarOpen, __setSnackbarOpen] = useState(false);
  const [__snackbarMessage, __setSnackbarMessage] = useState("");
  const [__snackbarVariant, __setSnackbarVariant] = useState("success");

  const [__loginUserId, __setLoginUserId] = useState("");

  const __navigate = useNavigate() 

  const __handleOpen = () => __setModalOpen(true);
  const __handleClose = () => __setModalOpen(false);

  const __checkVariantNameExists = async (aVariantName) => {
    const _getProductId = sessionStorage.getItem("_selectedProductID");
    try {

      const _getSelectedVariant = await axios.get(`/product/${_getProductId}`);
      const _productVariantData = _getSelectedVariant.data.data.productAssociation?.map((aItem) => ({
        variantName:aItem.variantId.variantName,
        variantDescription:aItem.variantId.variantDescription,
        isVisible:aItem.isVisible ? 'Inactive' : 'Active',
        id: aItem.variantId._id,
      }));

      const _matchingWithNameAndId = _productVariantData.filter(variant => 
        variant.variantName !== aVariantName || variant.id !== variantId
    );

      const _foundVariantName = _matchingWithNameAndId.find(variant => variant.variantName === aVariantName);
      if(_foundVariantName){
      __setVariantExists(true);
      __setCheckMessage("This variant name is already in use for this product.");
      __setSuggestions([]);  
      __setIsVariantNameValid(false);
      }else{
        if (!__clickFetchSuggestionList) {
        __fetchVariantSuggestions(aVariantName);
        }
      __setVariantExists(false);
      __setCheckMessage("This variant name is available for this product.");
      __setIsVariantNameValid(true); 
      }
    } catch (error) {
      console.error("Error checking product name:", error);
    }
  };

  const __fetchVariantSuggestions = async (aInput) => {
    try {
      __setFetchingSuggestions(true);
      const _variantResponse = await axios.post("/variant/search", { query: aInput });
      console.log("__fetchVariantSuggestions",_variantResponse);
      __setSuggestions(_variantResponse.data.data); 
      __setFetchingSuggestions(false);
    } catch (error) {
      console.error("Error fetching variant suggestions:", error);
      __setFetchingSuggestions(false);
    }
  };

  const __handleVariantNameChange = (aEventObject) => {
    const _variantValue = aEventObject.target.value;
    const _regex = /^[a-zA-Z0-9 ]*$/;
    __setVariantNameValue(_variantValue);

    if (_variantValue.trim().toLowerCase() === "all") {
      __setErrorMessage('Variant name "All" or "all" is not allowed.');
      __setVariantExists(false);
      __setCheckMessage('');
      __setIsVariantNameValid(false);
      return; 
    }

    if (!_regex.test(_variantValue)) {
      __setErrorMessage('Special characters are not allowed.');
      __setVariantExists(false);
      __setCheckMessage('');
      __setIsVariantNameValid(false);
      return; 
    }

    __setErrorMessage("");

    if (_variantValue.trim().length > 0) {
      __setClickFetchSuggestionList(false);
      __checkVariantNameExists(_variantValue);
    } else {      
      __setSuggestions([]);
    }
  };

  const __updateVariantDescription = (aDescriptionValue) => {    
    __setVariantDescription(aDescriptionValue);
  };

  const __handleSelectVariant = (variantName) => {
    __setVariantNameValue(variantName); // Set selected variant name
    __setClickFetchSuggestionList(true);
    __setSuggestions([]); // Clear suggestions after selection
    __checkVariantNameExists(variantName);
  };

  const __handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    __setSnackbarOpen(false);
  };

  const __triggerSnackbar = (message, variant) => {
    __setSnackbarMessage(message);
    __setSnackbarVariant(variant);
    __setSnackbarOpen(true);
  };

  const __updateVariantFunc = async (e) => {
    e.preventDefault();
    __setModalOpen(false);
    __setLoading(true);

    let _variantData = {
      variantName: __variantNameValue,
      variantDescription: __variantDescription,
      userId: __loginUserId
      //isVisible: isVisible
    };
    
    const _updateVariantData = await axios.put(`/variant/update/${variantId}`, _variantData);
    if(_updateVariantData.data.status=="success"){
      __setLoading(false);
      __triggerSnackbar("The variant has been updated successfully.","success"); 
      ///__setMessageStatus("success");
      //__setSuccessMsg("The product has been updated successfully.");
    }else{
      __setLoading(false);
      __triggerSnackbar("Failed to update variant.","error"); 
      //__setMessageStatus("failed");
      //__setSuccessMsg("Failed to update product.");
    }
  };

  useEffect(() => {
    const __fetchProduct = async () => {
      try {
        console.log(variantId);
        const _response = await axios.get(`/variant/${variantId}`);
        console.log("fetchProduct",_response.data.data)
        __setProductData(_response.data.data);
        __setVariantNameValue(_response.data.data.variantName);
        __setVariantDescription(_response.data.data.variantDescription);
      } catch (error) {
        console.error("Error fetching product data:", error);
      }
    };
    __fetchProduct();
    __setCurrentVariantId(variantId);

    const _getLoginUserId = localStorage.getItem("adminId");
    if(_getLoginUserId){
      __setLoginUserId(_getLoginUserId);
    }
  }, [variantId]);

  return (
    <div style={{ marginTop: "0",position:"relative" }}> 
      <PageHeading title="Edit Variant" style={{marginBottom:"20px"}} />
      <Box
        sx={{
          height: "auto",
          width: "60%",
          margin:"auto auto auto auto",
          marginTop:"0px",
          ul: {
            bgcolor: "#f6f6f6",
            color: "#ffffff",
          },
        }}
       >
        <Grid container spacing={2} style={{ marginBottom: 20 }}>
            <Grid item sm={12}>
              <TextField
                id="variant"
                label="Variant Name"
                variant="outlined"
                size="small"
                required
                type="text"
                style={{ width: "100%" }}
                value={__variantNameValue || ""} 
                onChange={__handleVariantNameChange}
                sx={textFieldAndShrinkStyle}
                error={!!__errorMessage || __variantNameValue === ""}
                helperText={__errorMessage || (__variantNameValue === "" ? "Variant Name is required." : "")}
              />

              
            {__errorMessage ==="" && __variantNameValue && <div style={{  fontSize:basic.contentFontSize,color: __variantExists ? 'red' : 'green' }}>{__checkMessage}</div>}


            {/* Suggestions list */}
            {__fetchingSuggestions && !__clickFetchSuggestionList ? (
              <CircularProgress style={{ color: basic.greenColor }} size={24} />
            ) : (
              __suggestions.length > 0 && !__clickFetchSuggestionList && (
                <List style={{ display:"block", backgroundColor:"#fff"}}>
                  {__suggestions.map((variantItem) => (
                    <ListItem
                      key={variantItem._id}
                      onClick={() => __handleSelectVariant(variantItem.variantName)}
                      style={{ color: basic.colorWhite, cursor:"pointer", backgroundColor:basic.logoGreyColor, borderRadius:"5px", marginRight:"5px", display:"inline-block", width:"auto", marginBottom:"5px", paddingTop:"5px",fontSize:basic.contentFontSize}}
                      title='Select Variant'
                      sx={{
                        "& li.MuiListItem-root:last-child": {
                          borderBottom: "0px",
                        },
                      }}  
                    >
                      {variantItem.variantName}
                    </ListItem>
                  ))}
                </List>
              )
            )}

              <TextField
                id="description"
                label="Variant Description"
                value={__variantDescription || ""}
                variant="outlined"
                size="small"
                required
                type="text"
                multiline
                rows={4}
                style={{ width: "100%", marginTop:"20px", marginBottom:"20px" }}
                onChange={(e) => { __updateVariantDescription(e.target.value)}}
                //onChange={(e) => __setVariantDescription(e.target.value)}
                error={__variantDescription === ""}
                sx={textFieldAndShrinkStyle}
                helperText={
                  __variantDescription === ""
                    ? "Variant description is required."
                    : ""
                }
              />
              <div style={{ margin: 10 }} />             

              <Grid container spacing={2} style={{ marginBottom: 20, marginLeft:"0px" }}>
                <CustomButton2
                onClick={__handleOpen}
                disabled={
                  !(__isVariantNameValid && __variantDescription && __variantDescription.length > 0) ||
                  __variantExists 
                }
                 aria-label="Save"
                >
                  <Save fontSize={basic.iconsFontSizeSmall} style={{ marginTop:-1 }}/>
                  <div style={{ marginLeft: 5 }}>Save</div>
                </CustomButton2>
                <CancelButton backToPage="/adminDashboard/product/variant" aButtonText="Cancel" />
              </Grid>
            
            </Grid>
            <Grid item sm={4}>
            </Grid>
        </Grid>
      </Box>

      <ModelPopup
        open={__modalOpen}
        onClose={__handleClose}
        onConfirm={__updateVariantFunc}
        title="Alert"
        description="Are you sure you want to update?"
        loading={__loading}
        successMsg={__successMsg}
        successStatus={__messageStatus}
        confirmText="Confirm"
        cancelText="Cancel"
        onGoToNext={() => { __navigate("/adminDashboard/product/variant") }}
        onFinalButtonText="Go to Variants"
      />

      <LoadingOverlay loading={__loading} />
      <MessageSnackbar
        message={__snackbarMessage}
        variant={__snackbarVariant}
        open={__snackbarOpen}
        onClose={__handleSnackbarClose}
      />

    </div>
  );
};

export default EditVariant;
